import React from "react";
import style from "./Mission.module.css";
export default function Mission() {
  const missionStatement = `“Our mission is rather simple; InvoZone is committed to helping its customers bring their products to market faster while reducing overall system development costs.”`;

  return (
    <div className={style.mainContainer}>
      <div className={style.textContainer}>
        <section className={style.heading}>
          <span>
            OUR <strong className={style.missionText}>MISSION</strong>
          </span>
        </section>
        <section className={style.description}>
          <span className={style.descriptText}>{missionStatement}</span>
        </section>
        <section className={style.footer}>
          <span className={style.footerText}>
            <strong>Furqan Aziz</strong> - CEO
          </span>
        </section>
      </div>
      <div className={style.imageContainer}>
        <img
          alt="CEO"
          src="https://invozone.com/wp-content/uploads/2020/05/owner-img-min.png"
          className={style.imgStyle}
        ></img>
      </div>
    </div>
  );
}
